import { MouseEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";

// import { Item } from "../../redux/shop/shop.types";
// import { CartItem } from "../../redux/cart/cart.types";
import { cartActions } from "../../redux/cart/cart.reducer";
import {
  selectCartItems,
  selectCartTotal,
  selectIsCartItemAdding,
  selectIsCartItemClearing,
  selectIsCartItemRemoving,
} from "../../redux/cart/cart.selectors";
import { selectShippingPrice } from "../../redux/checkout/checkout.selectors";

import useStyles from "./checkout-cart.styles";

import Price from "../../components/price";
import ClearItemInCart from "../../components/clear-item-in-cart";
import StripeIcon from "../../assets/icons/stripe-icon";
import Loading from "../../components/loading";
import { addItem, clearItem, removeItem } from "../../redux/cart/cart.utils";
import { selectCurrentUser } from "../../redux/user/user.selectors";

const CartItem = (props: any) => {
  const {
    cartItem,
    index,
    removeItemFromCart,
    addItemToCart,
    clearItemFromCart,
  } = props;

  const currentUser = useSelector(selectCurrentUser);

  const isAdding = useSelector(selectIsCartItemAdding);
  const isRemoving = useSelector(selectIsCartItemRemoving);
  const isClearing = useSelector(selectIsCartItemClearing);

  const [processing, setProcessing] = useState(false);
  const [clearing, setClearing] = useState(false);

  useEffect(() => {
    if (!isAdding && !isRemoving) {
      setProcessing(false);
    }
  }, [isAdding, isRemoving]);

  useEffect(() => {
    if (!isClearing) {
      setClearing(false);
    }
  }, [isClearing]);

  const classes = useStyles(props);

  return (
    <div className={classes.cartItem} style={{ gridRow: `${index + 2}` }}>
      {clearing ? (
        <div
          style={{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <Loading
            on
            size="2rem"
            marginLeft="auto"
            marginRight="auto"
            marginBottom="1rem"
          />
        </div>
      ) : (
        <>
          <Link
            to={`/shop/product?collectionId=${
              cartItem.collectionId
            }&productId=${
              cartItem.sk.includes("PROD")
                ? cartItem.sk
                : cartItem.pk.split("#")[1]
            }`}
            className={classes.info}
          >
            {cartItem?.defaultImage ? (
              <img src={cartItem?.defaultImage} className={classes.image} />
            ) : (
              <div className={classes.image}>No Image</div>
            )}
            <div className={classes.brandAndNameAndOption}>
              <div className={classes.brand}>{cartItem?.brand}</div>
              <div className={classes.name}>{cartItem.title}</div>
              {cartItem?.variantOptionsUsed &&
              cartItem?.variantOptionsUsed.variantOptions ? (
                <div className={classes.option}>
                  {_.sortBy(
                    Object.keys(cartItem?.variantOptionsUsed?.variantOptions),
                    [(o) => o],
                  ).map((key: any) => (
                    <span key={key}>
                      {key}: {cartItem?.variantOptionsUsed?.variantOptions[key]}
                    </span>
                  ))}
                </div>
              ) : null}
            </div>
          </Link>
          <div className={classes.quantity}>
            <button
              className={classes.removeOrAddBtn}
              onClick={() => {
                if (cartItem?.quantity > 1) {
                  removeItemFromCart(cartItem);
                } else {
                  setClearing(true);
                  clearItemFromCart(cartItem);
                }
                if (currentUser) {
                  setProcessing(true);
                }
              }}
            >
              -
            </button>
            {processing ? (
              <Loading on size="1rem" />
            ) : (
              <div>{cartItem?.quantity}</div>
            )}
            <button
              className={classes.removeOrAddBtn}
              onClick={() => {
                addItemToCart(cartItem);
                if (currentUser) {
                  setProcessing(true);
                }
              }}
            >
              +
            </button>
          </div>
          <div className={classes.price}>
            <Price item={cartItem} />
          </div>
          <div className={classes.total}>
            $
            {(
              (cartItem.priceSalesNow
                ? cartItem.priceSalesNow
                : cartItem.priceNow) * cartItem.quantity
            ).toFixed(2)}
          </div>
          <ClearItemInCart
            item={cartItem}
            clearItemFromCart={clearItemFromCart}
            setClearing={setClearing}
          />
        </>
      )}
    </div>
  );
};

const CheckoutCartPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const currentUser = useSelector(selectCurrentUser);

  const cartItems = useSelector(selectCartItems);
  const totalPrice = useSelector(selectCartTotal);
  const shippingPrice = useSelector(selectShippingPrice);

  const estimatedTax = shippingPrice
    ? (totalPrice + shippingPrice) * 0.13
    : totalPrice * 0.13;

  const [isLoading, setIsLoading] = useState(true);

  const fetchCart = () => {
    dispatch({
      type: cartActions.fetchCartStart.type,
      payload: "aidensung",
    });
  };

  useEffect(() => {
    if (currentUser) {
      fetchCart();
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 500);

    window.scrollTo({
      top: 0,
    });
  }, []);

  const classes = useStyles({
    isCartEmpty: cartItems.length === 0,
  });

  const addItemToCart = (item: any) => {
    addItem(dispatch, currentUser, null, 1, null, item);
  };

  const removeItemFromCart = (item: any) => {
    removeItem(dispatch, currentUser, item);
  };

  const clearItemFromCart = (item: any) => {
    clearItem(dispatch, currentUser, item);
  };

  const handleCheckoutClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      history.push("information");
    }, 1000);
  };

  return (
    <div className={classes.container}>
      <div className={classes.shoppingBag}>
        <button
          className={classes.continueBtn}
          onClick={() => {
            history.goBack();
          }}
        >
          Continue Browsing
        </button>
        <div className={classes.shoppingBagText}>Shopping Bag</div>
        <div className={classes.cart}>
          <div className={classes.cartHeader}>
            <div className={classes.quantityHeader}>Quantity</div>
            <div className={classes.priceHeader}>Price</div>
            <div className={classes.totalHeader}>Total</div>
          </div>
          <div className={classes.cartItems}>
            {cartItems && Array.isArray(cartItems) && cartItems.length !== 0 ? (
              _.orderBy(
                [...cartItems],
                ["title", "priceSalesNow", "priceNow", "cartItemId"],
                ["asc", "desc", "desc", "asc"],
              ).map((cartItem: any, index: number) => (
                <CartItem
                  key={cartItem.sk}
                  cartItem={cartItem}
                  index={index}
                  removeItemFromCart={removeItemFromCart}
                  addItemToCart={addItemToCart}
                  clearItemFromCart={clearItemFromCart}
                />
              ))
            ) : (
              <div>Shopping Bag is Empty</div>
            )}
          </div>
        </div>
        <StripeIcon />
      </div>
      <div className={classes.summary}>
        <div className={classes.summaryInner}>
          <div>
            <span>SubTotal</span>
            <span>CAD ${totalPrice.toFixed(2)}</span>
          </div>
          <div>
            <span>Shipping</span>
            <span>
              {shippingPrice
                ? `CAD $${shippingPrice.toFixed(2)}`
                : shippingPrice === 0
                ? "FREE"
                : "-"}
            </span>
          </div>
          <div>
            <span>Estimated Tax</span>
            <span>
              {estimatedTax && typeof estimatedTax === "number"
                ? `CAD $${estimatedTax.toFixed(2)}`
                : "-"}
            </span>
          </div>
          <div className={classes.horizontalLine} />
          <div className={classes.estimatedTotal}>
            <span>Estimated Total</span>
            <span>
              {`CAD $${(
                totalPrice +
                (shippingPrice ? shippingPrice : 0) +
                (estimatedTax ? estimatedTax : 0)
              ).toFixed(2)}`}
            </span>
          </div>
          <Link
            to="information"
            onClick={handleCheckoutClick}
            className={classes.checkoutBtn}
          >
            <button disabled={cartItems.length === 0}>Checkout</button>
          </Link>
        </div>
      </div>
      <Loading fullScreen on={isLoading} size="3rem" />
    </div>
  );
};

export default CheckoutCartPage;
